import { useEffect } from 'react';
import CancelablePromiseManager from "../component/CancelablePromiseManager";
var useCancelablePromise = function useCancelablePromise() {
  var promiseManager = new CancelablePromiseManager();
  useEffect(function () {
    return function () {
      promiseManager.cleanup();
    };
  }, []);
  return {
    createCancelablePromise: promiseManager.createCancelablePromise,
    addCancelablePromise: promiseManager.addCancelablePromise
  };
};
export default useCancelablePromise;